import queryString from 'query-string';

export const getParameterByName = (name: string, search?: string): string => {
  const parsedParameter = queryString.parse(search || window.location.search);
  const parsedValue = parsedParameter[name];

  // if there are multiple parameters of the same name, use the value of the first parameter in URL
  // https://www.pivotaltracker.com/n/projects/2485694/stories/184935974
  if (Array.isArray(parsedValue)) return parsedValue[0];
  return parsedValue;
};

export const getQueryString = (queryParams: Record<string, string>): string => {
  return `?${queryString.stringify(queryParams)}`;
};

export const updateQueryString = (
  queryParams: Record<string, string>,
  search?: string,
): string => {
  let parsed = queryString.parse(search || window.location.search);
  parsed = {
    ...parsed,
    ...queryParams,
  };
  return `?${queryString.stringify(parsed)}`;
};

export const removeQueryString = (
  paramsToRemove: string[],
  search?: string,
): string => {
  const parsed = queryString.parse(search || window.location.search);
  paramsToRemove.forEach((param) => {
    delete parsed[param];
  });
  return `?${queryString.stringify(parsed)}`;
};
